import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterHelperService, DropdownOption} from './positions-filter.helper';

@Component({
  selector: 'app-positions-filter',
  templateUrl: './positions-filter.component.html',
  styleUrl: './positions-filter.component.scss',
})
export class PositionsFilterComponent implements OnInit, OnChanges {
  @Input() rowData: any[] = [];
  @Output() filterApplied = new EventEmitter<{data: any[], buttonClicked: string}>();

  opened = false;
  openForm = true;
  filterForm!: FormGroup;

  // Dropdown options
  monthYearOptions: DropdownOption[] = [];
  lobOptions: DropdownOption[] = [];
  vendorOptions: DropdownOption[] = [];
  jobTitleOptions: DropdownOption[] = [];
  projectNameOptions: DropdownOption[] = [];

  constructor(
    private fb: FormBuilder,
    private filterHelper: FilterHelperService
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    this.loadDropdownOptions();
  }

  ngOnChanges(): void {
    if (this.rowData?.length) {
      this.loadDropdownOptions();
    }
  }

  private initializeForm(): void {
    this.filterForm = this.fb.group({
      monthYear: [null],
      lob: [null],
      vendor: [null],
      jobTitle: [null],
      projectName: [null],
    });
  }

  apply(): void {
    const filters = this.filterForm.value;
    const extractedFilters = this.filterHelper.extractFilterValues(filters);
    const filteredData = this.filterHelper.filterData(this.rowData, extractedFilters);

    this.filterApplied.emit({data:filteredData, buttonClicked: 'apply'});
    this.opened = false;
  }

  reset(): void {
    this.filterForm.reset();
    this.toggleForm();
    this.filterApplied.emit({data: this.rowData || [], buttonClicked: 'reset'});
  }

  private toggleForm(): void {
    this.openForm = false;
    setTimeout(() => this.openForm = true, 10);
  }

  private loadDropdownOptions(): void {
    if (!this.rowData?.length) return;

    this.monthYearOptions = this.filterHelper.generateMonthYearOptions(this.rowData);
    this.lobOptions = this.filterHelper.generateSimpleOptions(this.rowData, 'lob');
    this.vendorOptions = this.filterHelper.generateVendorOptions(this.rowData);
    this.jobTitleOptions = this.filterHelper.generateSimpleOptions(this.rowData, 'jobTitle');
    this.projectNameOptions = this.filterHelper.generateSimpleOptions(this.rowData, 'project');
  }
}